interface MultilineTextProps {
  children: string;
  className?: string;
}

export const MultilineText = ({ children, className = '' }: MultilineTextProps) => (
  <p className={`whitespace-pre-line [overflow-wrap:anywhere] ${className}`}>{children}</p>
);
